"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CheckboxState = /** @class */ (function () {
    function CheckboxState() {
        this.isChecked = false;
    }
    return CheckboxState;
}());
exports.default = CheckboxState;
//# sourceMappingURL=CheckboxState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Checkbox/CheckboxState.js
// module id = 1118
// module chunks = 8